import ContactInfo from "./components/ContactInfo";
import Description from "./components/Description";
import QuickLinks from "./components/QuickLinks";

export default function Footer() {
  return (
    // bg-[#00012b]
    <footer className="bg-dark-slate">
      <div className="container">
        <div className="flex items-start justify-between text-white gap-10 py-10 max-md:flex-col max-md:items-center max-md:text-center">
          {/* *********************************************************************************************************** */}

          <Description />

          {/* *********************************************************************************************************** */}

          <QuickLinks />

          {/* *********************************************************************************************************** */}

          <ContactInfo />

          {/* *********************************************************************************************************** */}
        </div>

        {/* *********************************************************************************************************** */}

        <hr />
        <p className="text-white text-center py-4">
          Designed By{" "}
          <span className="text-primary-green font-bold inline-block">
            Ali El-Shoraa
          </span>
        </p>
      </div>
    </footer>
  );
}
